import type { ShellResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** The signed-in member and their inbox count, for the sidebar (SHL-001). */
export function useShell() {
  return useQuery({
    queryKey: ['pages', 'shell'],
    queryFn: () => apiRequest<ShellResponse>('/api/pages/shell'),
    // The figures change once an hour; a minute is plenty fresh for a badge.
    staleTime: 60_000,
  });
}
